import { useSelector } from 'react-redux';

import { selectLocaleImprovementsEnabled } from 'core/userContext';
import { TemplatePayloadGenerator } from 'modules/campaigns/lib/hooks/useGenerateSaveTemplatePayload/types';
import { Locale } from 'modules/domains/template';
import { HtmlEditor } from 'modules/graphql';
import {
  SelectedMessageMedium,
  TemplateAndContentFormDataLocale,
} from 'modules/templateEditor/common';

export const useGenerateSaveTemplatePayload = (
  templatePayloadGenerator: TemplatePayloadGenerator,
) => {
  const isLocaleImprovementsEnabled = useSelector(selectLocaleImprovementsEnabled);

  return function generateUpdateTemplatePayload(
    templateData: TemplateAndContentFormDataLocale,
    medium: SelectedMessageMedium,
    projectLocales: Locale[],
    currentLocale: string,
    templateHtmlEditor: HtmlEditor | undefined,
    formData?: TemplateAndContentFormDataLocale,
    defaultLocaleTag?: string | undefined,
    newLocaleExperience?: boolean,
  ) {
    return templatePayloadGenerator(
      templateData,
      medium,
      projectLocales,
      currentLocale,
      templateHtmlEditor,
      formData,
      defaultLocaleTag,
      newLocaleExperience ?? isLocaleImprovementsEnabled,
    );
  };
};
